export const resolveRuntimeWindow = (): Window | null => {
  if (typeof globalThis !== 'object' || globalThis === null) {
    return null;
  }

  if (!('window' in globalThis)) {
    return null;
  }

  const candidate = (globalThis as typeof globalThis & { window?: Window | null }).window;
  return candidate ?? null;
};
